import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IUserPreferences} from "../../../user/interfaces/IUserPreferences";
import {getAvailableAndSearchedRooms} from "../form/get_available_and_searched_rooms";

interface ICalculateRoomsFieldParams {
    offer?: IOfferDetailApplication;
    propertyId?: number;
    userPreferencesFilters: IUserPreferences["filters"];
}

export function calculateRoomsField(params: ICalculateRoomsFieldParams) {
    const {offer, propertyId} = params;
    const availableRooms = (offer && offer.stats && offer.stats.rooms) || [];

    if (propertyId) {
        return [];
    }

    return getAvailableAndSearchedRooms(availableRooms, params.userPreferencesFilters);
}
import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {IUserPreferences} from "../../../user/interfaces/IUserPreferences";
import {getAvailableAndSearchedRooms} from "../form/get_available_and_searched_rooms";

interface ICalculateRoomsFieldParams {
    offer?: IOfferDetailApplication;
    propertyId?: number;
    userPreferencesFilters: IUserPreferences["filters"];
}

export function calculateRoomsField(params: ICalculateRoomsFieldParams) {
    const {offer, propertyId} = params;
    const availableRooms = (offer && offer.stats && offer.stats.rooms) || [];

    if (propertyId) {
        return [];
    }

    return getAvailableAndSearchedRooms(availableRooms, params.userPreferencesFilters);
}
